import { useState } from 'react';
import Report from '../business_logic/repositories/report';

import Config from '../utils/config';

const reportClient = new Report(Config.backendUrl);

const useDownloadFile = () => {
  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const downloadFile = (data: any, fileName: string) => {
    const urlLink = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = urlLink;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(urlLink);
  };

  const getFile = async (url: string, fileName: string) => {
    setLoading(true);
    try {
      const data = await reportClient.getReport(url, fileName);
      downloadFile(data, fileName);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getManualFile = async (
    url: string,
    fileName: string,
    notionfile: File,
    bamboofile: File,
    EYFile: File,
  ) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('notion_file', notionfile);
    formData.append('bamboo_file', bamboofile);
    formData.append('ey_file', EYFile);
    try {
      const data = await reportClient.getManualReport(url, fileName, formData);
      downloadFile(data, fileName);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      throw new Error('The report is not generated, please check the files');
    }
  };

  return { getFile, getManualFile, loading };
};

export default useDownloadFile;
